<template lang="pug">
div.animated.fadeIn
  // conclusion by duration
  b-card
    div.row
      div.col-sm-4
      div.col-sm-8
        div.dateRangePickerContainer
          i(class="fa fa-calendar")
          date-range-picker.ml-2.dateRangePicker(ref="ref" :options="options")
          i(class="fa fa-caret-down")
    br
    div(id='graphContainer' style='height: 500px')
</template>

<script>
// import { db } from '@/firebase'
import echarts from 'echarts'
import $ from 'jquery'
import sampleData from './sample-data.json'
var moment = require('moment')
// const anaRef = db.ref('analytics')

export default {
  name: 'dashboard',
  data() {
    return {
      initialise: true,
      userAccessLevel: this.$store.state.profile.accessLevel,
      // for date range picker
      options: {
        startDate: moment('20190826').subtract(29, 'days'),
        endDate: moment('20190826'),
        locale: {
          format: 'DD/MM/YYYY',
        },
        ranges: {
          'Last 7 Days': [moment('20190826').subtract(6, 'days'), moment('20190826')],
          'Last 30 Days': [moment('20190826').subtract(29, 'days'), moment('20190826')],
          'This Month': [moment('20190826').startOf('month'), moment('20190826').endOf('month')],
          'Last Month': [moment('20190826').subtract(1, 'month').startOf('month'), moment('20190826').subtract(1, 'month').endOf('month')],
        },
      },
      sliderEndPoint: '',
      sliderStartPoint: '',
      option: null,
      fullData: null,
    }
  },
  mounted: function() {
    const el = $(this.$refs.ref.$el)
    el.on('apply.daterangepicker', (event, picker) => {
      let data = JSON.parse(JSON.stringify(this.fullData))
      let sliderStartTime = new Date(picker.startDate.format('L'))
      let sliderEndTime = new Date(picker.endDate.format('L'))
      Object.entries(data).forEach(function([key, val]) {
        const day = key.substring(6)
        const month = key.substring(4, 6)
        const year = key.substring(0, 4)
        let keyTime = new Date(`${month}-${day}-${year}`)
        if (keyTime < sliderStartTime) {
          delete data[key]
        } else if (keyTime > sliderEndTime) {
          delete data[key]
        }
      })
      this.loadData(data)
    })
    this.getGraph()
  },
  methods: {
    getGraph() {
      this.fullData = sampleData.daily
      let data = JSON.parse(JSON.stringify(sampleData.daily))
      let sliderEndTime = new Date(`08-26-2019`)
      let sliderStartTime = new Date(sliderEndTime - 30 * 24 * 60 * 60 * 1000)
      Object.entries(data).forEach(function([key, val]) {
        const day = key.substring(6)
        const month = key.substring(4, 6)
        const year = key.substring(0, 4)
        let keyTime = new Date(`${month}-${day}-${year}`)
        if (keyTime < sliderStartTime) {
          delete data[key]
        } else if (keyTime > sliderEndTime) {
          delete data[key]
        }
      })
      this.loadData(data)
    },
    loadData(data) {
      var dom = document.getElementById('graphContainer')
      var myChart = echarts.init(dom)
      var intentNameArray = []
      var intentNumberArray = []
      var initialise = true
      let summedTopics = {}
      Object.entries(data).forEach(function([key, val]) {
        const dailyDatas = Object.values(val)
        Object.entries(dailyDatas[0]).forEach(([intentName, intentData]) => {
          if (initialise == true) {
            summedTopics = {
              'SmallTalks': {interactions: 0},
              'General Info': {interactions: 0},
              'Cust Service': {interactions: 0},
              'Getting There': {interactions: 0},
              'Products': {interactions: 0},
              'Stock Price': {interactions: 0},
              'Booking': {interactions: 0},
              'Membership': {interactions: 0},
              'CDN': {interactions: 0},
              'Broker': {interactions: 0},
              'Sector': {interactions: 0},
              'Latest News': {interactions: 0},
            }
            initialise = false
          }
          if (!summedTopics[intentName] && !intentName.includes('ST0') && !intentName.includes('ST7') && !intentName.includes('i10') && !intentName.includes('i11') && !intentName.includes('i12') && !intentName.includes('i20') && !intentName.includes('i21') && !intentName.includes('i22') && !intentName.includes('i23') && !intentName.includes('i31') && !intentName.includes('i32') && !intentName.includes('i33') && !intentName.includes('i34') && !intentName.includes('tt ') && !intentName.includes('TT ') && !intentName.includes('Room-FreeRoom') && !intentName.includes('Get Started - ')) {
            summedTopics[intentName] = {
              interactions: 0,
            }
          }
          if (intentName.includes('ST0') || intentName.includes('ST7')) {
            summedTopics['SmallTalks'].interactions += intentData.interactions || 0
          } else if (intentName.includes('i10')) {
            summedTopics['General Info'].interactions += intentData.interactions || 0
          } else if (intentName.includes('i11')) {
            summedTopics['Cust Service'].interactions += intentData.interactions || 0
          } else if (intentName.includes('i12')) {
            summedTopics['Getting There'].interactions += intentData.interactions || 0
          } else if (intentName.includes('i20')) {
            summedTopics['Products'].interactions += intentData.interactions || 0
          } else if (intentName.includes('i21')) {
            summedTopics['Stock Price'].interactions += intentData.interactions || 0
          } else if (intentName.includes('i22')) {
            summedTopics['Booking'].interactions += intentData.interactions || 0
          } else if (intentName.includes('i23')) {
            summedTopics['Membership'].interactions += intentData.interactions || 0
          } else if (intentName.includes('i31')) {
            summedTopics['CDN'].interactions += intentData.interactions || 0
          } else if (intentName.includes('i32')) {
            summedTopics['Broker'].interactions += intentData.interactions || 0
          } else if (intentName.includes('i33')) {
            summedTopics['Sector'].interactions += intentData.interactions || 0
          } else if (intentName.includes('i34')) {
            summedTopics['Latest News'].interactions += intentData.interactions || 0
          } else if (intentName.includes('tt ') || intentName.includes('TT ') || intentName.includes('Room-FreeRoom') || intentName.includes('Get Started - ')) {
          } else {
            summedTopics[intentName].interactions += intentData.interactions || 0
          }
        })
      })
      // convert object into array
      Object.entries(summedTopics).forEach(([intentName, intentData]) => {
        intentNameArray.push(intentName)
        intentNumberArray.push(intentData.interactions || 0)
      })

      // search for index from biggest to smallest then arrange it
      var keysSorted = []
      for (var i = 0; i < intentNumberArray.length; i++) {
        keysSorted.push(i)
      }
      keysSorted.sort(function(a, b) { return intentNumberArray[b] - intentNumberArray[a] })
      let topIntentNumberArrayTop = []
      let topIntentNameArray = []
      for (let i = 0; i < intentNumberArray.length; i += 1) {
        topIntentNumberArrayTop.push(intentNumberArray[keysSorted[i]])
        topIntentNameArray.push(intentNameArray[keysSorted[i]])
      }

      // put into data format that graph understand
      var legendData = []
      var seriesData = []
      var selected = {}
      for (let i = 0; i < topIntentNumberArrayTop.length; i++) {
        legendData.push(`${topIntentNameArray[i]}`)
        seriesData.push({
          name: `${topIntentNameArray[i]}`,
          value: topIntentNumberArrayTop[i],
        })
        selected[`${topIntentNameArray[i]}`] = true
      }

      this.setOption(legendData, seriesData, selected)
      if (this.option && typeof this.option === 'object') {
        myChart.setOption(this.option, true)
      }
    },
    setOption(legendData, seriesData, selected) {
      this.option = {
        backgroundColor: '#fff',
        animation: false,
        title: {
          top: 5,
          left: 5,
          text: 'Intents Summary Pie Chart',
        },
        toolbox: {
          orient: 'vertical',
          top: 5,
          right: 20,
          showTitle: false,
          feature: {
            dataZoom: {
              yAxisIndex: false,
              show: false,
            },
            restore: {},
            saveAsImage: {},
          },
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'shadow',
            animation: false,
            shadowStyle: {color: 'rgba(50,181,217,0.1)'},
          },
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1,
          transitionDuration: 0.1,
          borderColor: '#ccc',
          padding: 10,
          textStyle: {
            color: '#000',
          },
          formatter: '{b} : {c} ({d}%)',
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          align: 'right',
          right: 20,
          top: 70,
          data: legendData,
          selected: selected,
        },
        series: [
          {
            name: 'Interactions',
            type: 'pie',
            radius: ['30%', '50%'],
            center: ['40%', '50%'],
            color: ['#6fdebd', '#93daa3', '#b3d48f', '#d0cd85', '#e8c485', '#f6bb8d', '#feb39c', '#ffaead', '#f6abc1', '#e4abd2', '#cbaede', '#afb2e3', '#7cbff3', '#24cbed', '#00d4cd', '#54d699', '#8cd179', '#b8c964', '#ddbf5e', '#eeb671', '#f3af88', '#efad9e', '#e3afaf'],
            data: seriesData,
            label: {
              normal: {
                formatter: '{b|{b}:}{c|{c}} {per|{d}%}',
                backgroundColor: '#fff',
                borderColor: '#666',
                borderWidth: 1,
                borderRadius: 4,
                rich: {
                  b: {
                    align: 'center',
                    fontSize: 12,
                    padding: [5, 5],
                  },
                  c: {
                    align: 'center',
                    fontSize: 12,
                    padding: [5, 5],
                    fontWeight: 'bold',
                  },
                  hr: {
                    borderColor: '#aaa',
                    width: '100%',
                    borderWidth: 0.5,
                    height: 20,
                  },
                  per: {
                    align: 'center',
                    color: '#eee',
                    fontSize: 12,
                    backgroundColor: '#666',
                    padding: [5, 5],
                    borderRadius: 3,
                  },
                },
              },
            },
            // label: {
            //   show: true,
            //   position: 'outside',
            //   color: '#333',
            // },
            itemStyle: {
              emphasis: {
                shadowBlur: 20,
                shadowOffsetX: 5,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Analytics/IntentsPie.vue?27998514